import axios from 'axios';
import { Account } from '../types/models';
import { API_BASE } from './config';

export async function getAccounts(): Promise<Account[]> {
  try {
    const res = await axios.get<Account[]>(`${API_BASE}/accounts`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function getAccount(address: string): Promise<Account> {
  try {
    const res = await axios.get<Account>(`${API_BASE}/accounts/${address}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function createAccount(account: Partial<Account>): Promise<Account> {
  try {
    const res = await axios.post<Account>(`${API_BASE}/accounts`, account);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function updateAccount(address: string, account: Partial<Account>): Promise<Account> {
  try {
    const res = await axios.put<Account>(`${API_BASE}/accounts/${address}`, account);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function deleteAccount(address: string): Promise<void> {
  try {
    await axios.delete(`${API_BASE}/accounts/${address}`);
  } catch (err) {
    throw err;
  }
}

export async function getAccountCounterparties(address: string): Promise<Account[]> {
  try {
    const res = await axios.get<Account[]>(`${API_BASE}/accounts/${encodeURIComponent(address)}/counterparties`);
    return res.data;
  } catch (err) {
    throw err;
  }
} 